export const reasons = [
  "Over 20 years of combined experience in window tint & paint protection film",
  "Professional installers",
  "Only quality materials",
  "Highest attention to details",
  "Rated Best XPEL Shop in Saskatchewan for 2 years in a row",
];
